import React from "react";
import { Link } from "react-router-dom";
import { FaTwitter, FaInstagram, FaGithub, FaArrowUp } from "react-icons/fa";
import { animateScroll as scroll } from "react-scroll";

export default function Footer() {
  return (
    <footer className="footer" id="footer">
      <div className="footer__container">
        <div className="footer__top">
          <div className="footer__statement">
            <span className="footer__eyebrow">Alex Rodriguez · Software Developer</span>
            <p className="footer__tagline">
              Let's build something<br />that lasts.
            </p>
          </div>
          <div className="footer__links">
            <span>Find me online</span>
            <div className="footer__socials">
              <a href="https://github.com/Sterki" aria-label="GitHub" target="_blank" rel="noreferrer">
                GitHub <FaGithub />
              </a>
              <a href="https://twitter.com/alexbyrod" aria-label="Twitter" target="_blank" rel="noreferrer">
                Twitter <FaTwitter />
              </a>
              <a href="https://www.instagram.com/alexbyrod_7" aria-label="Instagram" target="_blank" rel="noreferrer">
                Instagram <FaInstagram />
              </a>
            </div>
          </div>
        </div>

        <div className="footer__bottom">
          <button className="footer__logo" onClick={() => scroll.scrollToTop()} aria-label="Scroll to top">
            AR<span>/</span>{new Date().getFullYear()}
          </button>
          <p>Designed and engineered with intention.</p>
          <nav className="footer__legal" aria-label="Legal">
            <Link to="/impressum">Impressum</Link>
            <Link to="/datenschutz">Datenschutz</Link>
          </nav>
          <button
            className="footer__scroll-top"
            onClick={() => scroll.scrollToTop()}
            aria-label="Scroll to top"
          >
            Back to top <FaArrowUp />
          </button>
        </div>
      </div>
    </footer>
  );
}
